export default {
    valueListsLoaded: 0,
    valueLists: [],
    valueList: null,
    fetchState: 'LATEST',
    values: [],
    history: [],
    localActivitiesExist: false,
    updateView: 0,
}